module.exports = __webpack_public_path__ + "img/chat.3823ebea.png";